import { Button, CircularProgress } from "@mui/material";
import { useState } from "react";

type Props = {
  onClick: () => Promise<void> | void;
  disabled?: boolean;
  label?: string;
};

export const CustomButton = ({
  onClick,
  disabled = false,
  label = "Button",
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const result = onClick();
      if (result instanceof Promise) {
        await result;
      }
    } catch (error) {
      console.error("Button action failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      disabled={disabled || isLoading}
      fullWidth
      style={{ height: 36, minHeight: 36 }}
      color="primary"
      variant="contained"
      onClick={handleClick}
    >
      {isLoading ? <CircularProgress size="1rem" color="inherit" /> : label}
    </Button>
  );
};
